import { Skeleton } from "@mui/material";

const UserSkeleton = () => {
  return (
    <div className="p-7 flex w-full gap-2 items-center">
      <Skeleton
        sx={{ bgcolor: "rgba(255,255,255,0.4)", minWidth: 70, minHeight: 70 }}
        animation="wave"
        variant="circular"
        width={70}
        height={70}
      />
      <div className="flex flex-col gap-1 w-full">
        <Skeleton
          animation="wave"
          height={20}
          width="90%"
          sx={{ bgcolor: "rgba(255,255,255,0.4)" }}
        />
        <Skeleton
          animation="wave"
          height={20}
          width="70%"
          sx={{ bgcolor: "rgba(255,255,255,0.4)" }}
        />
      </div>
    </div>
  );
};

export default UserSkeleton;
